import { SearchValueType } from './search-value-type';

export class FilterValueTypeChangeMapper {
  public static map(type: SearchValueType): SearchValueType {
    //Add any changes to the list below
    let _valueTypeChangeList: { oldType: string; newType: SearchValueType }[] = [
      { oldType: 'Document', newType: SearchValueType.EmptyOperator },
    ];

    let result = _valueTypeChangeList.find((x) => x.oldType == type);
    if (!result) return type;
    return result.newType;
  }
}
